<template>
  <div>
    <Card>
      <p slot="title"> Tambah Nota Transaksi </p>
      <Row type="flex" justify="space-between">
        <Col span="9">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Bank Account</Button>
              <Select
                v-model="bankAccountId"
                placeholder="Select Bank"
                clearable
                filterable
                @on-change="updateFilter">
                  <Option
                      v-for="bankAccount in bankAccounts"
                      :value="bankAccount.id"
                      :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
              </Select>
          </ButtonGroup>
        </Col>

        <Col span="6">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Tgl. Transaksi</Button>
              <Date-picker
                  v-model="filterTransactionDate"
                  placeholder="Select Date"
                  style="width: 100%;"
                  type="daterange"
                  format="yyyy-MM-dd"
                  @on-change="updateFilter">
              </Date-picker>
          </ButtonGroup>
        </Col>

        <Col span="6">
            <ButtonGroup class="custom-group-parent">
                <Button class="custom-group">Marking &nbsp;&nbsp;&nbsp;</Button>
                <Select
                    style="width: 100%;"
                    v-model="markingIdSelected"
                    placeholder="Select Marking"
                    filterable
                    clearable
                    :remote-method="getMarkingByCode"
                    :loading="isLoadingMarking"
                    @on-change="updateFilter">
                    <Option v-for="option in optionMarkings"
                        :value="option.value" :key="option.value">{{option.label}}</Option>
                </Select>
            </ButtonGroup>
        </Col>

        <!-- <Col span="1">
            <Spin size="large" v-show="isLoadingMarking"></Spin>
        </Col> -->

        <Col span="2">
            <Button type="primary" icon="ios-search" @click="getTransactionNote" :disabled="!isSearchShow">
              <span>Cari</span>
            </Button>
        </Col>
      </Row>

      <br/>

      <Card>
          <Table :columns="columnsDataTable" :data="transactionNoteData" @on-selection-change="onSelectionChange"></Table>
      </Card>
    </Card>

    <div class="footer" v-show="transactionNoteCreate.length > 0">
        <Button
            type="success"
            @click="modalConfirmMultipleCreate = true"
            icon="plus"
            size="small"  >
                <span>Create nota transaksi</span>
        </Button>
    </div>

    <!-- Modal Confirm Multiple Create -->
    <Modal v-model="modalConfirmMultipleCreate" width="50rem">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Konfirmasi</span>
        </p>
        <div style="text-align:left;">
            <div v-for="data in transactionNoteCreate">
                <Tag color="blue"> Marking : {{ data.markingheadercode }} | {{ data.paymentDate }} | {{ cleanDescription(data.description) }}</Tag>
                <!-- <Tag color="blue">{{ data.paymentDate }}</Tag>
                <Tag color="blue">{{ data.description }}</Tag> -->
            </div>
        </div>
        <div slot="footer">
            <Button
                type="error" size="large" long icon="plus"
                :loading="isCreate"
                @click="createTransactionNote(transactionNoteCreate)"
                >Create nota transaksi</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'

import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');

export default {
    data () {
        return {
            bankAccounts: [],
            bankAccountId: null,
            filterTransactionDate: [],
            markingIdSelected: '',
            isSearchShow: false,
            optionMarkings: [],
            isLoadingMarking: false,
            columnsDataTable: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: 'Tgl. Pembayaran',
                    key: 'paymentDate'
                },
                {
                    title: 'Marking',
                    key: 'markingheadercode'
                },
                {
                    title: 'Keterangan',
                    type: 'html',
                    width: 450,
                    key: 'descriptionDetail'
                },
                {
                    title: 'Jumlah',
                    key: 'amount'
                },
                {
                    title: 'Bank Account',
                    key: 'bankAccount'
                },
            ],
            transactionNoteData: [],
            transactionNoteCreate: [],
            modalConfirmMultipleCreate: false,
            isCreate: false
        }
    },
    methods: {
        showDateFormatted : function(stringToFormat){
          let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
          return moment(dateToFormat).format("DD MMM YYYY")
        },

        getBankAccount: function() {
          HTTP.get("bankAccount/findAll/active")
            .then(response => {
              this.bankAccounts = response.data;
            })
            .catch(e => {
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            });
        },

        getMarkingByCode: _.debounce(
          function (query) {
            if (query !== '') {
                this.isLoadingMarking = true;
                HTTP
                .post('marking/getBySnapshot', {
                    markingHeaderId: query
                })
                .then(response => {
                    this.isLoadingMarking = false;
                    let data = response.data;

                    const list = data.map(item => {
                        return {
                            value: item.markingheaderid,
                            label: item.markingheadercode
                        };
                    });

                    this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                })
                .catch(e => {
                    this.isLoadingMarking = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            } else {
                this.optionMarkings = [];
            }
          }, 400
        ),

        updateFilter: function() {
          let fBankAccount = this.bankAccountId;
          let fTrxDate = this.filterTransactionDate;
          let fMarkingSelected = this.markingIdSelected;

          // if((fTrxDate[0] != '' && fTrxDate[0] != null) || (fMarkingSelected != '' && fMarkingSelected != undefined) || (fBankAccount != '' && fBankAccount != undefined)) {
          // di set jadi mandatory
          // if((fMarkingSelected != '' && fMarkingSelected != undefined) && (fBankAccount != '' && fBankAccount != undefined)) {
          if((fTrxDate[0] != '' && fTrxDate[0] != null) && (fBankAccount != '' && fBankAccount != undefined)) {
            this.isSearchShow = true
          }else {
            this.isSearchShow = false
          }
        },

        getTransactionNote: function(){
          this.$Loading.start();
          this.transactionNoteCreate = [];

          let fBankAccount = this.bankAccountId != "" && this.bankAccountId != undefined ? this.bankAccountId : null;;
          let fStartDate = null;
          let fEndDate = null;
          if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
              fStartDate = moment(this.filterTransactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
              fEndDate = moment(this.filterTransactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }
          let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

          let payload = {
              isTrxNote: true,
              dateCreateFrom: fStartDate,
              dateCreateTo: fEndDate,
              markingHeaderId: fMarkingSelected,
              bankAccountId: fBankAccount
          }

          this.transactionNoteData = [];
          HTTP.post('payment/history', payload)
          .then(response => {
              let parent = this;
              console.log({response});

              // combine data by pendingId
              let paymentCombined = response.data.map(item => item.pendingId); // collect payments
              console.log({paymentCombined});

              let groupedByPendingId = {};

              _.forEach(response.data, function(value) {
                  let invoiceDetails = '';
                  let receivableIdInvoiceDue = '';
                  let pendingId = value.pendingId;

                  _.forEach(value.payment_allocate, function(payAllocate) {
                      if (payAllocate.invoice_due.receivable != null){
                          let paymentSum = payAllocate.invoice_due.paymentSum
                          paymentSum = numeral(paymentSum).format('0,0')

                          let deptName = ""
                          if(payAllocate.invoice_due.receivable.invoice != null){
                              deptName = payAllocate.invoice_due.receivable.invoice.item_dept.deptName
                          }

                          let invoiceDetail = "- " + deptName
                          invoiceDetail += " - " + payAllocate.invoice_due.receivable.description + " - Rp " + paymentSum
                          invoiceDetails += invoiceDetail + " <br/>"

                          receivableIdInvoiceDue = payAllocate.invoice_due.receivableId // untuk join transaction_note yg mempunyai sisa tagihan (pembayaran > 1)
                      }
                  });

                  let description = value.receivable.description
                  let descriptionDetail = '<span class="bold">' + description + '</span> <br/>' + invoiceDetails

                  if (value.category == 'disc') {
                      descriptionDetail = '<span class="bold red">' + description + '</span> <br/><span class="red">' + invoiceDetails + '</span>'
                  }

                  let payment = {
                      paymentId : value.id,
                      pendingId : pendingId,
                      paymentDate : value.paymentDate,
                      markingheadercode : value.receivable.marking_minified.markingheadercode,
                      description : description,
                      descriptionDetail : descriptionDetail,
                      bankAccountId : value.pending.bank_account.id,
                      bankAccount : value.pending.bank_account.accountName,
                      amount : value.receivable.creditAmount,
                      receivableIdInvoiceDue : receivableIdInvoiceDue
                  }

                  // buat array baru jika pendingId belum di groupedByPendingId
                  if (!groupedByPendingId[pendingId]) {
                    groupedByPendingId[pendingId] = [];
                  }

                  // kelompokkan data berdasarkan pendingId
                  groupedByPendingId[pendingId].push(payment);

                  // parent.transactionNoteData.push(payment);
              });

              // console.log({groupedByPendingId});

              let groupedByPendingIdV2 = Object.entries(groupedByPendingId).map(([pendingId, payments]) => ({
                pendingId: Number(pendingId),
                payments
              }));

              // console.log({groupedByPendingIdV2});

              _.forEach(groupedByPendingIdV2, function(groupedBPId) {
                  let tempNewPay = []
                  let vpaymentId = ''
                  let vpendingId = ''
                  let vpaymentDate = parent.showDateFormatted(groupedBPId.payments[0].paymentDate)
                  let vmarkingheadercode = ''
                  let vdescription = ''
                  let vdescriptionDetail = ''
                  let vbankAccountId = groupedBPId.payments[0].bankAccountId
                  let vbankAccount = groupedBPId.payments[0].bankAccount
                  let vamount = ''
                  let vreceivableIdInvoiceDue = ''

                  _.forEach(groupedBPId.payments, function(payment) {
                      vpaymentId += payment.paymentId + ', ',
                      vpendingId += payment.pendingId + ', ',
                      // vpaymentDate += parent.showDateFormatted(payment.paymentDate) + '<hr/>',
                      vmarkingheadercode += payment.markingheadercode + ', ',
                      vdescription += payment.description + '<hr/>',
                      vdescriptionDetail += payment.descriptionDetail + '<hr/>',
                      // vbankAccountId += payment.bankAccountId + '<hr/>',
                      // vbankAccount += payment.bankAccount + '<hr/>',
                      vamount += numeral(payment.amount).format('0,0') + ', ',
                      vreceivableIdInvoiceDue += payment.receivableIdInvoiceDue + ', '

                      tempNewPay = {
                          paymentId : vpaymentId.replace(/, $/, ''), // Menghapus ', ' di akhir teks
                          pendingId : vpendingId.replace(/, $/, ''), // Menghapus ', ' di akhir teks
                          paymentDate : vpaymentDate,
                          markingheadercode : vmarkingheadercode.replace(/, $/, ''), // Menghapus ', ' di akhir teks
                          description : vdescription.replace(/<hr\/>$/, ''), // Menghapus <hr/> di akhir teks
                          descriptionDetail : vdescriptionDetail.replace(/<hr\/>$/, ''), // Menghapus <hr/> di akhir teks
                          bankAccountId : vbankAccountId,
                          bankAccount : vbankAccount,
                          amount : vamount.replace(/, $/, ''), // Menghapus ', ' di akhir teks
                          receivableIdInvoiceDue : vreceivableIdInvoiceDue.replace(/, $/, ''), // Menghapus ', ' di akhir teks
                      }
                  });

                  // console.log({tempNewPay});
                  parent.transactionNoteData.push(tempNewPay);
              });

              this.$Loading.finish();
          })
          .catch(e => {
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          });
        },

        cleanDescription(description) {
          return description.replace(/<hr\/>.*$/, ''); // hapus konten setelah <hr/>
        },

        onSelectionChange:function(selection){
          console.log({selection});
          let paymentDates = selection.map(item => item.paymentDate); // collect paymentDate
          let matchDates = paymentDates.every(date => date === paymentDates[0]); // compare paymentDate dengan data pertama

          if (!matchDates) {
            this.transactionNoteCreate = []
            this.$Notice.warning({
                title: "Perhatian !",
                desc: "Tanggal pembayaran harus sama",
                duration: 3
            });
          } else {
            // split and clean up comma-separated values
            function splitAndClean(data) {
              return data
                .split(',') // convert string by comma
                .map(item => item.trim()) // clear space yang tidak perlu
                .filter(item => item !== ''); // delete elemen kosong
            }

            const processedData = selection.map(item => ({
              ...item,
              paymentId: splitAndClean(item.paymentId),
              // pendingId: splitAndClean(item.pendingId),
              // markingheadercode: splitAndClean(item.markingheadercode),
              // amount: splitAndClean(item.amount),
              receivableIdInvoiceDue: splitAndClean(item.receivableIdInvoiceDue),
            }));

            console.log("Processed Data", processedData);

            this.transactionNoteCreate = processedData
          }
        },

        createTransactionNote(dataTrx) {
          this.isCreate = true

          let payload = {
            dataTrx : dataTrx
          }

          console.log("Payload :");
          console.log({payload});

          HTTP
          .post('transaction-note/create', payload)
          .then(response => {
            console.log("post response :", response);

            this.$Loading.finish();
            this.$Message.success('Nota transaksi berhasil dibuat !');

            this.isCreate = false
            this.modalConfirmMultipleCreate = false
            this.getTransactionNote(); // update list
          })
          .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc:e,
                duration: 5
            });
          })
        }
    },

    mounted() {
      this.$Loading.config({
          color: '#ffffff',
          failedColor: '#f0ad4e',
          height: 10
      });

      this.getBankAccount();
    }
}
</script>

<style>
    .bold { font-weight: bold; }
    .red { color: red; }
</style>



// WEBPACK FOOTER //
// PaymentTransactionNoteNew.vue?7e6dc31e